//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        showBillboard () {
            this.cancel()
            this.$emit('showBillboard')
        },
        cancel () {
            this.$emit('hide')
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        shadow: {
            type: Boolean,
            default: true
        },
        shareMsg: {
            type: String,
            default: '保存图片'
        }
    }
}
